import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      gap: '1rem',
      paddingRight: '1.8rem',
    },

    input: {
      width: '100%',

      '& > div': {
        width: '100%',
        margin: 0,
      },
    },

    area: {
      width: '100%',
      background: '#f4f4f4',
      paddingLeft: '1rem',
      border: `solid 1px ${theme.palette.secondary.light}`,
      borderRadius: 4,

      '& > p': {
        fontSize: '1.6rem',
        lineHeight: '4.6rem',
      },
    },

    removeButton: {
      border: `solid 1px ${theme.palette.secondary.light}`,
      borderRadius: 4,

      '& > button': {
        padding: '1.1rem',
        width: '100%',
        height: '100%',
        borderRadius: 4,
        color: theme.palette.secondary.main,
      },
    },
  }),
)
